<template>
  <div style='display: flex;flex-direction: column;align-items: center;'>
    <el-form label-width="150px">
      <el-form-item label="时间区间:">
        <el-col :span="8">
          <el-form-item>
            <el-date-picker type="date" v-model="dateRange1" placeholder="选择开始日期时间"
                            style="width: 100%;" clearable placement="bottom-start"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="2"> ————</el-col>
        <el-col :span="8">
          <el-form-item>
            <el-date-picker type="date" v-model="dateRange2" placeholder="选择结束日期时间"
                            style="width: 100%;" clearable placement="bottom-start"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-button type="primary" @click="chearAndInitData">查询</el-button>
        </el-col>
      </el-form-item>
    </el-form>

    <el-table :data="data" border stripe>
      <el-table-column type="id" label="id" prop="id"></el-table-column>
      <el-table-column type="id" label="变量编号" prop="variableId"></el-table-column>
      <el-table-column label="变量名" prop="variableName"></el-table-column>
      <el-table-column label="值" prop="variableValue"></el-table-column>
      <el-table-column label="更新时间" prop="updateTime"></el-table-column>
      <el-table-column label="查看图表" width="100px">
        <template v-slot="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini"
                     @click='dialogTableVisible=true;variableId=scope.row.variableId'>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange"
                   :current-page="pageNum" :page-sizes="[10]" :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <el-dialog title="历史值图表" :visible.sync="dialogTableVisible">
      <history-graph v-if='dialogTableVisible' :companyId='companyId' :varId='varIds' :dateRange1='dateString1'
                     :dateRange2='dateString2' :pageNum='pageNum' :pageSize='pageSize'
                     :suffix='variableId'></history-graph>
    </el-dialog>

  </div>
</template>

<script>
import API from "@/../config/api.js";
import HistoryGraph from "../Graphs/HistoryGraph.vue";

export default {
  props: ['companyId', 'varIds'],
  components: {
    HistoryGraph
  },
  data() {
    return {
      data: [],
      dialogTableVisible: false,
      variableId: "",
      test: "",
      pageNum: 1,
      pageSize: 10,
      dateRange1: "",
      dateString1: "",
      dateRange2: "",
      dateString2: "",
      total: 0, //总数据条数
    }
  },
  async mounted() {
    this.initData();
  },
  methods: {
    chearAndInitData() {
      this.total = 0;
      this.data = [];
      this.pageNum = 1;
      this.pageSize = 10;
      if (this.dateRange1 && this.dateRange1 != null) {
        this.dateString1 = this.dateFormat("YYYY-mm-dd HH:MM:SS", this.dateRange1);
      } else {
        this.dateString1 = "";
      }
      if (this.dateRange2 && this.dateRange2 != null) {
        this.dateString2 = this.dateFormat("YYYY-mm-dd HH:MM:SS", this.dateRange2);
      } else {
        this.dateString2 = "";
      }
      this.initData();
    },
    async initData() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      var varIdString = this.varIds;

      console.log(varIdString)
      let data = {
        companyId: this.companyId,
        ids: varIdString,
        dateRange1: this.dateString1 ? this.dateString1 : "",
        dateRange2: this.dateString2 ? this.dateString2 : "",
      }
      if (this.pageNum) {
        Object.assign(data, {pageNum: this.pageNum});
      }
      if (this.pageSize) {
        Object.assign(data, {pageSize: this.pageSize});
      }
      let ret = await this.$axiosRequest({
        url: API.getVariableHisValueList,  //后面根据端口修改
        method: 'POST',
        data: data,
        header: header,
      })
      this.data = ret[1].data.hisValueList;
      this.total = ret[1].data.total;
      console.log(ret[1].data);
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage;
      this.initData();
    },
    //日期转化函数
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }

      }
      return fmt;
    },
  },
}
</script>

<style>

</style>
